import { connect } from 'react-redux';
import * as actions from '../../actions/tools';
import { UsersTool } from '../../components/tools';

const mapStateToProps = state => ({
  usergroups: state.map.usergroups,
  tracks: state.map.currentDay && state.map.currentDay.tracks,
  filter: state.tools.usersFilter,
  filterActive: state.tools.usersFilterActive,
});

const mapDispatchToProps = dispatch => ({
  onFilterActive: active => dispatch(actions.setUsersFilterActive(active)),
  onFilterChange: filter => dispatch(actions.setUsersFilter(filter)),
  onFilterClear: () => dispatch(actions.setUsersFilter('')),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersTool);



// WEBPACK FOOTER //
// ./src/containers/tools/UsersTool.js